export let PRICE_SIMPLE = 8000
export const PRICE_EXPRESS = 0
export const PRICE_OVER_PAGE = 400

export let PRICE_SIMPLE_FOR_HYBRID = 9850
export const PRICE_OVER_PAGE_FOR_HYBRID = 300
